import { useIntl } from 'react-intl';

import { groupingMessages } from '../groupingMessages';
import { GroupCountBadge } from './GroupCountBadge';
import { GroupTag } from './GroupTag';

import type { GroupFamily, GroupView } from '../../domain/grouping.types';

export interface GroupsMenuListProps {
  family: GroupFamily;
  groups: GroupView[];
  onEdit: (groupId: string) => void;
}

function GroupRowContent({ family, group }: Readonly<{ family: GroupFamily; group: GroupView }>) {
  return (
    <>
      <GroupTag groups={[group]} id={`groupsMenu-tag-${group.id}`} />
      <span className="groupsMenu__name">{group.name}</span>
      <GroupCountBadge count={group.memberCount} family={family} />
    </>
  );
}

/** Menu content for an item in several groups: one row per group; editable rows open that group's edit. */
export function GroupsMenuList({ family, groups, onEdit }: Readonly<GroupsMenuListProps>) {
  const { formatMessage } = useIntl();

  return (
    <ul className="groupsMenu__list">
      {groups.map(group => (
        <li key={group.id}>
          {group.editable ? (
            <button
              aria-label={formatMessage(groupingMessages.editGroupNamed, { name: group.name })}
              className="groupsMenu__row groupsMenu__row--clickable"
              onClick={() => onEdit(group.id)}
              type="button"
            >
              <GroupRowContent family={family} group={group} />
              <i aria-hidden className="groupsMenu__editIcon fa-regular fa-pen-to-square" />
            </button>
          ) : (
            <div className="groupsMenu__row">
              <GroupRowContent family={family} group={group} />
            </div>
          )}
        </li>
      ))}
    </ul>
  );
}
